import { ActionType } from "../action-type.constant.t";
import { Company } from "../types";

type CompanyAction = {
  type: string;
  payload?: Company;
};

const initState ={
  companyId:0,
  logoOssUrl: 'https://oss.1qizhuang.com/default/default-company.png',
}

export default function companyReducer(state:Company = initState, action:CompanyAction) {
  switch (action.type) {
    case ActionType.SET_COMPANY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}